export default {
    ca: {
        title: 'Compartir el mapa',
        labelLink: 'Per enllaçar amb aquest mapa, copieu i enganxeu el següent text:',
        labelIframe: 'Per inserir aquest mapa al vostre web, copieu i enganxeu el següent text:',
    },
    es: {
        title: 'Compartir el mapa',
        labelLink: 'Para enlazar con este mapa, copia y pega el siguiente texto:',
        labelIframe: 'Para insertar este mapa en tu web, copia y pega el siguiente texto:',
    },
    en: {
        title: 'Share the map',
        labelLink: 'To link to this map, copy and paste the following text:',
        labelIframe: 'To insert this map into your website, copy and paste the following text:',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/compartir-modal/compartir-modal-translations.js